

define(['squid/index', './directive'], function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xo-add-card.addcep.route', ['squid', 'xo-add-card.addcep.directive']).factory('$AddCepRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('AddCepRoute', {
      name: 'addCep',
      directive: 'xo-add-cep',
      titleContent: 'addBillingAddress.title',
      loginRequired: true,
      children: []
    });
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addCep/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addCep/route.js
// module chunks = 0